import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import SendEmailService from "@/services/SendEmailService";
import Navigation from "../../NavigationContainer.vue";
import InquiryNavigation from "../../InquiryNavigationContainer.vue";
import InquiryLinkNavigation from "../../InquiryLinkNavigationContainer.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { useI18n } from "vue3-i18n";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const email = ref("");
const reEmail = ref("");
const confirmEmail = ref("");
const name = ref("");
const title = ref("New User Invitation");
const message = ref("");
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();

const sendCheckedEmail = () => {
  // 2023/05/16 MDCR 修正 start
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = {
    id: store.getters.cognitoUserName,
    address: email.value,
    isSend: true,
    targetMailFormat: "mail_message",
    sendingPattern: "userInvite"
  };
  // 2023/05/16 MDCR 修正 end
  SendEmailService.sendEmail(data)
    .then((response: ResponseData) => {
      name.value = "";
      email.value = "";
      reEmail.value = "";
      message.value = "";
      // 2023/05/15 MDCR 修正 start
      confirmEmail.value = "";
      alertMessage.value = i18n.t("suc034");
      alertState.value = "success";
      // 2023/05/15 MDCR 修正 end
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = "This address is missing '@domain name'";
      alertState.value = "error";
    });
};
const sendEmail = () => {
  // 2023/05/16 MDCR 修正 start
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = {
    id: store.getters.cognitoUserName,
    address: email.value,
    isSend: false,
    targetMailFormat: "mail_message",
    sendingPattern: "userInvite"
  };
  // 2023/05/16 MDCR 修正 end
  SendEmailService.sendEmail(data)
    .then((response: ResponseData) => {
      if (typeof response.data === "string") {
        // 2023/05/15 MDCR 修正 start
        message.value = response.data + ". Are you really sure to send email?";
        confirmEmail.value = email.value;
        // 2023/05/15 MDCR 修正 end
      } else {
        alertMessage.value = i18n.t("suc034");
        alertState.value = "success";
        name.value = "";
        email.value = "";
        reEmail.value = "";
        message.value = "";
      }
    })
    .catch((e: Error) => {
      console.log(e);
    });
};
const cancel = () => {
  name.value = "";
  email.value = "";
  reEmail.value = "";
  message.value = "";
  // 2023/05/15 MDCR 修正 start
  confirmEmail.value = "";
  // 2023/05/15 MDCR 修正 end
};

const __returned__ = { email, reEmail, confirmEmail, name, title, message, alertMessage, alertState, i18n, sendCheckedEmail, sendEmail, cancel, Navigation, InquiryNavigation, InquiryLinkNavigation, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})